import { IQuery, Topics } from '@zaplify/common';

export class PurchaseProspectsCommand extends IQuery<string[]> {
    public static override readonly TOPIC = Topics.PROSPECTS;
    constructor(readonly userId: string, readonly personIds?: string[]) {
        super();
    }
}
